import React, { useMemo } from 'react';
import { Card } from 'antd';
import { Draggable, Droppable } from 'react-beautiful-dnd';
import map from 'lodash/map';
import isEmpty from 'lodash/isEmpty';
import toString from 'lodash/toString';
import uniqueId from 'lodash/uniqueId';
import size from 'lodash/size';
import filter from 'lodash/filter';
import add from 'lodash/add';
import cn from 'classnames';

import PlaylistCard from '../PlaylistCard';
import Empty from '@components/snippets/Empty';
import Loader from '@components/snippets/Loader';
import PlaylistNewCard from './PlaylistNewCard';
import { useTranslation } from 'react-i18next';

const Playlist = React.memo(function Playlist({
  items,
  loading,
  onDelete,
  onChangeItemDuration,
}) {
  const { t } = useTranslation();

  return (
    <div className="scroll-with-padding">
      <Card className="playlist__cards-container">
        <div
          className={cn(
            'playlist__cards playlist__cards--full playlist__cards--static',
            {
              'playlist__cards--empty': isEmpty(items),
            }
          )}
        >
          <Droppable droppableId="droppable2">
            {(provided, snapshot) =>
              !loading && isEmpty(items) ? (
                <div
                  className="h-100 d-flex align-center justify-center"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <Empty text={t('playlist-empty')} />
                </div>
              ) : (
                <div
                  className="h-100 align-center justify-center"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  <Loader loading={loading} />
                  {map(items, (item, index) => (
                    <Draggable
                      key={`drag-${toString(item.uId)}`}
                      draggableId={`drag-${toString(item.uId)}`}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <div
                          className="playlist-card__container"
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          style={provided.draggableProps.style}
                        >
                          <PlaylistCard
                            {...item}
                            index={index}
                            number={index + 1}
                            full
                            onDelete={onDelete}
                            onChangeDuration={onChangeItemDuration}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )
            }
          </Droppable>
        </div>
      </Card>
    </div>
  );
});

Playlist.whyDidYouRender = true;

export default Playlist;
